import { Store } from './store';

const store = new Store();

export { store };

export {
  userActions,
  patientActions,
  ECGActions,
  patientsActions,
  facilityActions,
  bloodPressureActions,
  studyActions,
} from './slice';
